import { showFailureToast, showSuccessToast } from "@helpers";
import { createAction, createSlice } from "@reduxjs/toolkit";

const deleteCourseSlice = createSlice({
  name: "deleteCourse",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      // alert("Delete course successful!");
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = deleteCourseSlice;
const deleteCourseAction = createAction(name);

export {
  deleteCourseAction,
  actions as deleteCourseActions,
  reducer as deleteCourseReducer,
};
